import {
  DAP_API,
  GRCNEST_BASE_URL,
  IAM_API,
  INTEGRATION_BASE_URL,
} from "./config";

// My Project
export const CURD_REQUEST_SEVERITY = `${DAP_API}/v1/api/piedap/severity`;

// ===========================================================================================
// ================================== Landing ================================================
// ===========================================================================================
export const CRUD_SERVICE = `${INTEGRATION_BASE_URL}/v1/api/piedap/service`;
export const GET_SERVICE_BY_INTEGRATION = `${INTEGRATION_BASE_URL}/v1/api/piedap/service_by_integration`;

export const CRUD_INTEGRATION_AWS = `${INTEGRATION_BASE_URL}/v1/api/piedap/custom/integration_aws`;
export const GET_INTEGRATION_AWS_BY_INTEGRATION = `${INTEGRATION_BASE_URL}/v1/api/piedap/custom/integration_aws_by_integration`;

// API TOKEN
export const CRUD_API_TOKEN = `${INTEGRATION_BASE_URL}/v1/api/piedap/api_token_integration`;
export const GET_API_TOKEN_BY_INTEGRATION = `${INTEGRATION_BASE_URL}/v1/api/piedap/api_token_integration_by_integration`;

// BASIC
export const CRUD_BASIC = `${INTEGRATION_BASE_URL}/v1/api/piedap/basic_integration`;
export const GET_BASIC_BY_INTEGRATION = `${INTEGRATION_BASE_URL}/v1/api/piedap/basic_integration_by_integration`;
export const GET_BASIC_STATUS = `${INTEGRATION_BASE_URL}/v1/api/piedap/basic_integration/update_status`;

// OAUTH
export const CRUD_OAUTH = `${INTEGRATION_BASE_URL}/v1/api/piedap/oauth_integration`;
export const GET_OAUTH_BY_INTEGRATION = `${INTEGRATION_BASE_URL}/v1/api/piedap/oauth_integration_by_integration`;
export const GET_OAUTH_DETAILS = `${INTEGRATION_BASE_URL}/v1/api/piedap/oauth_integration_by_id`;
export const GET_OAUTH_STATUS = `${INTEGRATION_BASE_URL}/v1/api/piedap/oauth_integration/update_status`;
export const GET_OAUTH_KEY = `${INTEGRATION_BASE_URL}/v1/api/piedap/oauth_integration/key`;
export const GET_OAUTH_CONNECT_URL = `${INTEGRATION_BASE_URL}/v1/api/piedap/connect`;
// ===========================================================================================
// ================================== Platform Config ========================================
// ===========================================================================================

// Integration
export const CRUD_INTEGRATION = `${INTEGRATION_BASE_URL}/v1/api/piedap/integration`;
export const GET_INTEGRATION_BY_CATEGORY = `${INTEGRATION_BASE_URL}/v1/api/piedap/integration_by_category`;
export const GET_INTEGRATION_DETAILS = `${INTEGRATION_BASE_URL}/v1/api/piedap/integration_by_id`;

// Asset Category
export const CRUD_ASSET_CATEGORY = `${INTEGRATION_BASE_URL}/v1/api/piedap/asset_category`;

// Asset Type
export const CRUD_ASSET_TYPE = `${INTEGRATION_BASE_URL}/v1/api/piedap/asset_type`;
export const GET_ASSET_TYPE = `${INTEGRATION_BASE_URL}/v1/api/piedap/asset_type_by_category`;

export const CRUD_INTEGRATION_SERVICE = `${INTEGRATION_BASE_URL}/v1/api/piedap/service_master`;
export const GET_SERVICE_MASTER_BY_INTEGRATION = `${INTEGRATION_BASE_URL}/v1/api/piedap/service_master_by_integration`;

export const CRUD_INTEGRATION_CHECK = `${GRCNEST_BASE_URL}/v1/api/piedap/control_check`;
export const GET_INTEGRATION_CHECK_BY_SERVICE = `${GRCNEST_BASE_URL}/v1/api/piedap/control_check_by_integration`;

// Integration Type
export const CRUD_CONNECTION_TYPE = `${INTEGRATION_BASE_URL}/v1/api/piedap/connection_type`;

// Integration OAuth
export const CRUD_INTEGRATION_OAUTH = `${INTEGRATION_BASE_URL}/v1/api/piedap/oauth_type`;

// Integration MCP
export const CRUD_INTEGRATION_MCP = `${INTEGRATION_BASE_URL}/v1/api/piedap/mcp_type`;

// External App Integration
export const EXTERNAL_APP_INTEGRATION = `${IAM_API}/v1/api/api-key`;

// FETCH USERS
export const GET_CUSTOMER_USER_ROLES = `${IAM_API}/v1/api/user-role/customer-user/project/fetch-all`;

// Tag Integration
export const TAG_INTEGRATION_CONNECTION = `${INTEGRATION_BASE_URL}/v1/api/piedap/integration_connection_type`;
export const GET_TAG_INTEGRATION_CONNECTION_BY_MASTER = `${INTEGRATION_BASE_URL}/v1/api/piedap/integration_connection_type_by_integration_master_id`;

// Project by Account
export const FETCH_PROJECT_BY_ACCOUNT = `${IAM_API}/v1/api/authentication/current-user-accounts-with-projects`;


// ===========================================================================================
// ================================== Setup Config ========================================
// ===========================================================================================

// Integration Master
export const CRUD_INTEGRATION_MASTER = `${INTEGRATION_BASE_URL}/v1/api/piedap/integration_master`;
export const CRUD_INTEGRATION_MASTER_BY_ASSET_TYPE = `${INTEGRATION_BASE_URL}/v1/api/piedap/integration_master_by_asset_category`;